import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "vat-tu-table__footer-value"
}
const _hoisted_3 = {
  key: 1,
  class: "vat-tu-table__footer-value vat-tu-table__footer-value--text"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "vat-tu-bien-ban-table__checkbox-wrap"
}
const _hoisted_6 = {
  key: 0,
  class: "vat-tu-bien-ban-table__checkbox-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_QuantityInputCustom = _resolveComponent("QuantityInputCustom")!
  const _component_CurrencyInputCustom = _resolveComponent("CurrencyInputCustom")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_VatTuTable = _resolveComponent("VatTuTable")!

  return (_openBlock(), _createBlock(_component_VatTuTable, {
    "table-id": "vat-tu-bien-ban-table",
    "table-class": "vat-tu-bien-ban-table",
    "empty-text": _ctx.emptyText,
    items: _ctx.displayItems,
    "row-class-name": _ctx.footerRowClassName,
    "show-stt-id": false,
    "span-method": _ctx.footerSpanMethod,
    "ten-max-width": 300
  }, {
    default: _withCtx(() => [
      (!_ctx.forPhieuNhapLe)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            width: _ctx.columnWidths.soLuongCan,
            align: "right",
            "header-align": "center",
            label: "SL",
            prop: "so_luong_can"
          }, {
            default: _withCtx((scope) => [
              (!_ctx.isFooterRow(scope.row))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatQuantity(scope.row.so_luong_nhap_toi_da)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["width"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, {
        width: _ctx.columnWidths.soLuongNhap,
        "header-align": "center",
        label: "SL nhập",
        prop: "so_luong_nhap"
      }, {
        default: _withCtx((scope) => [
          (!_ctx.isFooterRow(scope.row))
            ? (_openBlock(), _createBlock(_component_QuantityInputCustom, {
                key: 0,
                id: `vat-tu-_so-luong-input_${_ctx.getItemIndex(scope.row) + 1}`,
                modelValue: scope.row.so_luong_trong_bien_ban,
                "onUpdate:modelValue": ($event: any) => ((scope.row.so_luong_trong_bien_ban) = $event),
                "is-disabled": !_ctx.isEditable,
                min: 0,
                "class-str": "w-100",
                placeholder: "Nhập số lượng",
                onInput: 
            (value) =>
              _ctx.onChangedSoLuongHandler(scope.row, _ctx.getItemIndex(scope.row), value)
          
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "is-disabled", "onInput"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_component_el_table_column, {
        width: _ctx.columnWidths.donGia,
        align: "right",
        "header-align": "center",
        label: "Đơn giá",
        prop: "don_gia"
      }, {
        default: _withCtx((scope) => [
          (!_ctx.isFooterRow(scope.row))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.allowEditingDonGia || !_ctx.isEditable)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(_ctx.formatUnitPrice(+scope.row.pivot.so_tien)), 1))
                  : (_openBlock(), _createBlock(_component_CurrencyInputCustom, {
                      key: `don-gia-${scope.row.id}`,
                      modelValue: scope.row.pivot.so_tien,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.pivot.so_tien) = $event),
                      "class-str": "w-100",
                      placeholder: "Đơn giá",
                      onInput: 
              ({ value }) =>
                _ctx.handleDonGiaUpdate({ index: _ctx.getItemIndex(scope.row), value })
            ,
                      onChange: 
              (value) =>
                _ctx.handleDonGiaUpdate({ index: _ctx.getItemIndex(scope.row), value })
            
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "onChange"]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_component_el_table_column, {
        width: _ctx.columnWidths.thanhTien,
        align: "right",
        "header-align": "center",
        label: "Thành tiền",
        prop: "thanh_tien"
      }, {
        default: _withCtx((scope) => [
          (scope.row._footerType === 'total')
            ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_ctx.formatAmount(_ctx.totalPriceInNumber)), 1))
            : (scope.row._footerType === 'text')
              ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(_ctx.totalPriceInText), 1))
              : (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(_ctx.formatAmount(
              _ctx.calcLineAmount(
                +scope.row.pivot.so_tien,
                +scope.row.so_luong_trong_bien_ban
              )
            )), 1))
        ]),
        _: 1
      }, 8, ["width"]),
      _createVNode(_component_el_table_column, {
        "header-align": "center",
        label: "KQ kiểm nghiệm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: _ctx.columnWidths.ketQuaKiemNghiem,
            align: "center",
            "class-name": "vat-tu-bien-ban-table__kq-checkbox-cell",
            "header-align": "center",
            "header-cell-class-name": "vat-tu-bien-ban-table__kq-sub-column",
            label: "Đạt",
            prop: "kq_dat"
          }, {
            default: _withCtx((scope) => [
              (!_ctx.isFooterRow(scope.row))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: scope.row.is_dat,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.is_dat) = $event),
                      disabled: "",
                      size: "large"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["width"]),
          _createVNode(_component_el_table_column, {
            width: _ctx.columnWidths.ketQuaKiemNghiem,
            align: "center",
            "class-name": "vat-tu-bien-ban-table__kq-checkbox-cell",
            "header-align": "center",
            "header-cell-class-name": "vat-tu-bien-ban-table__kq-sub-column",
            label: "Không đạt",
            prop: "kq_khong_dat"
          }, {
            default: _withCtx((scope) => [
              (!_ctx.isFooterRow(scope.row))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!scope.row.is_dat)
                      ? (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 0,
                          checked: "",
                          disabled: "",
                          size: "large"
                        }))
                      : (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 1,
                          disabled: "",
                          size: "large"
                        }))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["width"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        "min-width": _ctx.columnWidths.phuongThucKiemNghiem,
        "header-align": "center",
        label: "PT kiểm nghiệm",
        prop: "phuong_thuc"
      }, {
        default: _withCtx((scope) => [
          (!_ctx.isFooterRow(scope.row))
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: scope.row.phuong_thuc,
                "onUpdate:modelValue": ($event: any) => ((scope.row.phuong_thuc) = $event),
                disabled: !_ctx.isEditable,
                placeholder: "PT kiểm nghiệm",
                onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select())),
                onInput: 
            (value) =>
              _ctx.onChangedPhuongThucHandler(_ctx.getItemIndex(scope.row), value)
          ,
                onMousewheel: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInput"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["min-width"])
    ]),
    _: 1
  }, 8, ["empty-text", "items", "row-class-name", "span-method"]))
}